// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mainNavigationStyles } from "@awc/Overrides/Widgets/Header/MainNavigation";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, layoutContainer } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        display: flex;
        column-gap: 28px;
        justify-content: flex-start;
        align-items: center;
        ${layoutContainer}
        flex-wrap: wrap;
        min-height: 50px;
    `,
};

mainNavigationStyles.itemWrapper = {
    css: css`
        position: relative;
        overflow: visible;
        display: flex;
        &:hover span + div {
            display: block;
        }
    `,
};
mainNavigationStyles.menuItemIcon = {
    css: css`
        display: none;
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        position: relative;
        &:after {
            content: "";
            background-color: ${color("secondary.main")};
            height: 6px;
            position: absolute;
            top: calc(100% - 6px);
            left: 0px;
            width: 0px;
            transition: width 300ms ease-in-out;
        }

        & > ${TypographyStyle} {
            display: flex;
            align-items: center;
            padding: 0;
            height: 50px;
            text-transform: capitalize;
        }

        &.primary > ${TypographyStyle} {
            &,
            & > ${IconWrapper} {
                color: ${color("common.white")};
            }
        }

        &[data-open],
        &:not([disabled]):hover {
            & > ${TypographyStyle} {
                color: ${color("common.white")};
            }
        }

        &:hover,
        &:focus {
            &:after {
                width: 100%;
            }
        }

        &&&&:focus-visible {
            outline: none;
        }

        &[data-open]:after {
            width: 100%;
        }
    `,
};

mainNavigationStyles.menuItemTypography = {
    size: fontConfig.fontSize.regular,
    color: "common.white",
    weight: fontConfig.weight.bold,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    ellipsis: true,
};

mainNavigationStyles.mobileWrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};
mainNavigationStyles.alliedUniversityMenu = {
    css: css`
        min-height: 135px;
        width: auto;
    `,
};

mainNavigationStyles.skeletonStyle = {
    css: css`
        border-radius: 2px;
    `,
};
